import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';
import { SecurityGateway } from 'src/app/application/gateway/SecurityGateway';
import { ProfileService } from 'src/app/application/service/ProfileService';
import { BasicUser, ProfileFlowSelection } from 'src/app/domain/models/User';
import { Routes } from 'src/app/infrastructure/routes';

@Component({
  selector: 'app-flow-selection-page',
  templateUrl: './flow-selection-page.component.html',
  styleUrls: ['./flow-selection-page.component.css'],

})
export class FlowSelectionPageComponent {

  user: BasicUser | undefined

  constructor(
    private readonly _authService: AuthGateway,
    private readonly _router: Router,
    private readonly _securityService: SecurityGateway,
    private readonly _profileService: ProfileService,
    private readonly _messageService: MessageService,
    public translateService: TranslateService,
  ) {}

  ngOnInit() {
    this.user = this._authService.getUser()
    if (localStorage.getItem('_selected_flow')) {
      this._router.navigate([Routes.homePage])
    }
  }

  // TODO aleyton: ajustar con endpoint real

  selectBoth() {
    let flowSelection: ProfileFlowSelection = {
      marketplace: true,
      program: true
    }

    this._profileService.profileFlowSelection(flowSelection).subscribe({
      next: (v) =>
      {
        localStorage.setItem('_selected_flow', 'marketplace-program')
      },
      error: (e) => {
        this._messageService.add({ severity: 'error',
          summary: this.translateService.instant('MessageService.Summary.FailedAction'),
          detail: this.translateService.instant('MessageService.FlowSelection.FlowSelectionError') });
      },
      complete: () => {
        this._router.navigate([Routes.userClosedSales]).then(() => { })
      }
    })

    if (this.user?.profileType === 'Importer') {
    this._router.navigate([Routes.userImportRequest]).then(() => { })
    }
    else {
      this._router.navigate([Routes.userExportOffers]).then(() => { })
    }

  }

  selectMarketplace() {

    let flowSelection: ProfileFlowSelection = {
      marketplace: true,
      program: false
    }

    this._profileService.profileFlowSelection(flowSelection).subscribe({
      next: (v) =>
      {
        localStorage.setItem('_selected_flow', 'marketplace')
      },
      error: (e) => {
        this._messageService.add({ severity: 'error',
          summary: this.translateService.instant('MessageService.Summary.FailedAction'),
          detail: this.translateService.instant('MessageService.FlowSelection.FlowSelectionError') });
      },
      complete: () => {
        this._router.navigate([Routes.userClosedSales]).then(() => { })
      }

    })

    if (this.user?.profileType === 'Importer') {
      this._router.navigate([Routes.userImportRequest]).then(() => { })
    }
    else {
      this._router.navigate([Routes.userExportOffers]).then(() => { })
    }
  }

  selectProgram() {
    let flowSelection: ProfileFlowSelection = {
      marketplace: false,
      program: true
    }

    this._profileService.profileFlowSelection(flowSelection).subscribe({
      next: (v) =>
      {
        localStorage.setItem('_selected_flow', 'program')
      },
      error: (e) => {
        this._messageService.add({ severity: 'error',
          summary: this.translateService.instant('MessageService.Summary.FailedAction'),
          detail: this.translateService.instant('MessageService.FlowSelection.FlowSelectionError') });
      },
      complete: () => {
        this._router.navigate([Routes.userClosedSales]).then(() => { })
      }
    })
  }

  logout(): void {
    this._securityService.doLogout().subscribe({
      next: (v) => {
        this._authService.logout()
        this._router.navigate([Routes.login])
      }
    })
  }
}
